// ...existing code...

import type { Offer } from "../../offersList/offersListTypes"

const buildHtmlGecontur = (offers: Offer[], headerUrl?: string) => {
  const rows = offers
    .map((o) => {
      const thumb = o.ImageURL
        ? `<td valign="top" style="width:200px;padding-right:16px"><img src="${o.ImageURL}" alt="${o.OfferTitle}" style="display:block;width:100%;height:auto;border-radius:6px"/></td>`
        : `<td style="width:200px;padding-right:16px"></td>`
      return `
        <tr>
          <td style="padding:14px 0;border-bottom:1px solid #e5e7eb">
            <table width="100%" cellpadding="0" cellspacing="0" style="font-family:Arial,sans-serif">
              <tr>
                ${thumb}
                <td valign="top">
                  <h3 style="margin:0 0 6px 0;color:#042054;font-size:18px">${
                    o.OfferTitle || "Oferta"
                  }</h3>
                  <p style="margin:0 0 8px 0;color:#4b5563;font-size:14px">${
                    o.AccommodationName || ""
                  }</p>
                  <p style="margin:0 0 10px 0;color:#111827;font-size:16px"><strong>Desde ${
                    o.LeadInPrice || ""
                  }</strong></p>
                  ${o.URL ? `<a href="${o.URL}" style="color:#042054;text-decoration:underline">Ver detalhes</a>` : ""}
                </td>
              </tr>
            </table>
          </td>
        </tr>`
    })
    .join("")

  return `
  <!doctype html>
  <html>
    <head>
      <meta charset="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <title>Newsletter Gecontur</title>
    </head>
    <body style="margin:0;background:#f9fafb;padding:0">
      <table width="100%" cellpadding="0" cellspacing="0" style="background:#f9fafb">
        <tr>
          <td>
            <table align="center" width="680" cellpadding="0" cellspacing="0" style="margin:0 auto">
              ${headerUrl ? `<tr><td><img src=\\"${headerUrl}\\" alt=\\"Newsletter Header\\" style=\\"display:block;width:100%;height:auto;border-radius:8px\\"/></td></tr>` : ""}
            </table>
            <table align="center" width="680" cellpadding="0" cellspacing="0" style="margin:0 auto;background:#ffffff;border-radius:8px;padding:0 24px">
              ${rows}
              <tr><td style="text-align:center;color:#6b7280;padding:20px 0;font-family:Arial,sans-serif;font-size:12px">© Gecontur</td></tr>
            </table>
          </td>
        </tr>
      </table>
    </body>
  </html>`
}

export default buildHtmlGecontur
